import { TPresenceItem } from '@/types/presences';

export const flattenCollection = <T extends TPresenceItem>(entries: T[]): T[] => {
  const result: T[] = [];
  function hasChildren<T extends { children?: unknown }>(entry: T): entry is T & { children: T[] } {
    return Array.isArray((entry as any).children);
  }

  for (const entry of entries) {
    if (hasChildren(entry)) {
      result.push(...entry.children);
    } else {
      result.push(entry);
    }
  }

  return result;
};
